import store from '../index'
import { isLoginTypes } from '.'

export const setIsLogin = boolean => {
  store.dispatch({ type: isLoginTypes.set, value: boolean })
}
